import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';

export default class SurveysDataIndex {

  constructor() {}

  render() {

	  // Check if an index page (if data-page includes 'Index' anywhere)
		ResearchFiltering();

 }

}
